/**
 * lineConverter — LINE entity → CadPrimitive (single open path of one segment).
 * RAW world mm coordinates (no applyOffset).
 */

import type { LineEntity } from "@dxf-ai-editor/drawing-model";

import type { CadConvertContext, CadPrimitive } from "../cadPrimitive";
import { resolvePlotStyle } from "./resolveStyle";

export function lineToPrimitives(
  entity: LineEntity,
  ctx: CadConvertContext,
): CadPrimitive[] {
  const style = resolvePlotStyle(entity, ctx);
  // PDF-6.3b — CTB/STB do-not-plot honour. The resolver flags
  // `entry.plot === false` (or `screen <= 0`) as `style.skip` and we drop the
  // primitive entirely; the sheet emitter additionally guards on the same flag.
  if (style.skip) return [];
  return [
    {
      type: "path",
      entityId: entity.id,
      layer: entity.layer ?? "0",
      start: { x: entity.start.x, y: entity.start.y },
      segments: [
        { kind: "line", to: { x: entity.end.x, y: entity.end.y } },
      ],
      closed: false,
      fill: "none",
      style,
    },
  ];
}
